import store from "@/store";
import { clearAuditSession } from "@/services/pageTrackingService";

export function clearStoredSession(): void {
  localStorage.clear();
  clearAuditSession();
  store.commit("clearAuthData");
  store.commit("clearRoledata");
  store.commit("clearRolePrivileges");
}

export function hasActiveStoredSession(): boolean {
  return Boolean(
    store.getters.authenticated &&
      store.getters.getIdToken &&
      store.getters.isTokenActive
  );
}
